module.exports = __webpack_public_path__ + "static/media/banner-background.7bef6893.jpg";